import React, { Component } from "react";
import styles from "./SlideItem.local.scss";
import classnames from "classnames";

export default class SlideListFetching extends Component {
  render() {
    let items = [];
    for (let i = 0; i < 3; i++) {
      items.push(
        <div className="row medium-11 false">
          <div className={classnames("medium-3", styles.slide_item)}>
            <ul>
              <li
                className={
                  this.props.extraSlidesInModal
                    ? classnames(styles.slide_card, styles.in_modal)
                    : styles.slide_card
                }
                style={{ width: this.props.withoutHeader ? "310px" : "320px" }}
              >
                <div className={styles.slide_container}>
                  <div className={`${styles.item} ${styles.gradiant}`}>
                    {""}
                  </div>
                </div>

                <div className={styles.informations_container}>
                  <div>
                    <div className={styles.information_bloc}>
                      <div className={`${styles.title}`}>
                        <div className={styles.list__row_groups_cell_wrapper}>
                          <h4 className={styles.gradiant}>{""}</h4>
                          <span className={styles.gradiant}>{""}</span>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.flags} ${styles.flags_icon}`}>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                    </div>

                    <div className={styles.status}>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                    </div>
                    <div className={styles.more_information}>
                      <div className={styles.actions_container}>
                        <div className={styles.actions} />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className={classnames("medium-3", styles.slide_item)}>
            <ul>
              <li
                className={
                  this.props.extraSlidesInModal
                    ? classnames(styles.slide_card, styles.in_modal)
                    : styles.slide_card
                }
                style={{ width: this.props.withoutHeader ? "310px" : "320px" }}
              >
                <div className={styles.slide_container}>
                  <div className={`${styles.item} ${styles.gradiant}`}>
                    {""}
                  </div>
                </div>

                <div className={styles.informations_container}>
                  <div>
                    <div className={styles.information_bloc}>
                      <div className={`${styles.title}`}>
                        <div className={styles.list__row_groups_cell_wrapper}>
                          <h4 className={styles.gradiant}>{""}</h4>
                          <span className={styles.gradiant}>{""}</span>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.flags} ${styles.flags_icon}`}>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                    </div>

                    <div className={styles.status}>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                    </div>
                    <div className={styles.more_information}>
                      <div className={styles.actions_container}>
                        <div className={styles.actions} />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className={classnames("medium-3", styles.slide_item)}>
            <ul>
              <li
                className={
                  this.props.extraSlidesInModal
                    ? classnames(styles.slide_card, styles.in_modal)
                    : styles.slide_card
                }
                style={{ width: this.props.withoutHeader ? "310px" : "320px" }}
              >
                <div className={styles.slide_container}>
                  <div className={`${styles.item} ${styles.gradiant}`}>
                    {""}
                  </div>
                </div>

                <div className={styles.informations_container}>
                  <div>
                    <div className={styles.information_bloc}>
                      <div className={`${styles.title}`}>
                        <div className={styles.list__row_groups_cell_wrapper}>
                          <h4 className={styles.gradiant}>{""}</h4>
                          <span className={styles.gradiant}>{""}</span>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.flags} ${styles.flags_icon}`}>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                    </div>

                    <div className={styles.status}>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                    </div>
                    <div className={styles.more_information}>
                      <div className={styles.actions_container}>
                        <div className={styles.actions} />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className={classnames("medium-3", styles.slide_item)}>
            <ul>
              <li
                className={
                  this.props.extraSlidesInModal
                    ? classnames(styles.slide_card, styles.in_modal)
                    : styles.slide_card
                }
                style={{ width: this.props.withoutHeader ? "310px" : "320px" }}
              >
                <div className={styles.slide_container}>
                  <div className={`${styles.item} ${styles.gradiant}`}>
                    {""}
                  </div>
                </div>

                <div className={styles.informations_container}>
                  <div>
                    <div className={styles.information_bloc}>
                      <div className={`${styles.title}`}>
                        <div className={styles.list__row_groups_cell_wrapper}>
                          <h4 className={styles.gradiant}>{""}</h4>
                          <span className={styles.gradiant}>{""}</span>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.flags} ${styles.flags_icon}`}>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                      <h3 className={styles.gradiant}>{""}</h3>
                    </div>

                    <div className={styles.status}>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                      <div className={styles.tags} style={{ border: "none" }}>
                        <div
                          className={
                            styles.list__row_groups_cell_wrapper_status
                          }
                        >
                          <h5 className={styles.gradiant}>{""}</h5>
                        </div>
                      </div>
                    </div>
                    <div className={styles.more_information}>
                      <div className={styles.actions_container}>
                        <div className={styles.actions} />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      );
    }
    return <div className={styles.item__fetching}>{items}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/SlideList/SlideListFetching.js